module.exports = [
  {
    path: "/productList/:dt",
    name: "图书列表",
    component: () => import("../../components/product/productList.vue"),
  },
  {
    path: "/detail",
    name: "详情页",
    component: () => import("../../components/product/detail.vue"),
  },
  {
    path: "/productWHList/:dt",
    name: "供应商图书列表",
    component: () => import("../../components/product/productWHList.vue"),
  },
  {
    path: "/whDetail",
    name: "供应商图书详情页",
    component: () => import("../../components/product/whDetail.vue"),
  },
];
